<template>
	<div>
		<div
		 v-if="filters.length"
		 class="d-flex align-center"
		>
	    <span class="font-weight-bold ml-5">Filters:</span>
	    <div v-for="filter in filters" :key="filter">
	      <v-chip
	        v-if="filter != ''"
	        class="mx-2"
	        close
	        color="#5096A8"
	        label
	        outlined
	        @click:close="remove(filter)"
	      >
	        {{ isNaN(filter) ? filter : labels[filter] }}
	      </v-chip>
	    </div>
	  </div>
	</div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['chartId', 'filterId', 'filters', 'labels'],
  methods: {
    ...mapMutations('discoveryServices', ['resetFilters']),
    remove (val) {
      this.resetFilters({ field: this.filterId, value: val })
	  this.$root.$emit('Histogram', { field: this.chartId, value: val })
      this.$emit('removeFilter', { field: this.chartId, value: val })
    }
  }
}
</script>
<style>

</style>
